import React, { Component } from "react";
import MessageList from "./MessageList";
import "../../LiveChat/Styles/index.css";
class LiveChat extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { ticket, icon, brand, username } = this.props;
    return (
      <div className="live-chat-container">
        <MessageList
          icon={icon}
          brand={brand}
          ticket={ticket}
          username={username}
        />
      </div>
    );
  }
}
export default LiveChat;



// WEBPACK FOOTER //
// ./src/screens/AdminSupport/LiveChat/index.js